<!-- Modal -->
<template>
    <div class="modal fade" id="addExistingUserModal" ref="addExistingUserModal" tabindex="-1" aria-labelledby="createLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <form @submit.prevent.stop="addUsersToClient">
                    <div class="modal-header">
                        <div class="w-100 d-flex justify-content-between align-items-start">
                            <div>
                                <h5 class="modal-title" id="addExistingUserModalLabel">Add Existing User</h5>
                                <small class="text-muted">Start typing email or username. Search begins after 3 characters.</small>
                            </div>
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                    </div>
                    <div class="modal-body">
                        <div class="form-group mb-3">
                            <input type="text" v-model="searchText" placeholder="Search users..." class="form-control" />
                        </div>

                        <div class="juniper-pick-list p-3 mb-4">
                            <div v-if="users.length && !inProgress"><b>Selected: {{ selectedUsers.length }}</b>
                                <table class="act-table mb-0 mt-2">
                                    <thead>
                                        <tr>
                                            <th class="act-col-id">#</th>
                                            <th>Name</th>
                                            <th>Email</th>
                                            <th>Status</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr class="act-row" :class="(selectedUsers.includes(user.id)) && 'selected'" v-for="user in users" :key="user.id + '-key'" @click="selectUser(user.id)">
                                            <td class="act-col-id act-muted">{{ user.id }}</td>
                                            <td>{{ user.name }}</td>
                                            <td class="act-muted">{{ user.email }}</td>
                                            <td>
                                                <span v-if="user.active" class="act-badge act-badge--active">Active</span>
                                                <span v-else class="act-badge act-badge--inactive">Inactive</span>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div v-if="!inProgress && !users.length">
                                No users data.
                            </div>
                            <div v-if="inProgress" class="text-center">
                                <div class="spinner-border" role="status">
                                    <span class="visually-hidden">Loading...</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="ju-modal-btn ju-modal-btn--muted" data-bs-dismiss="modal">Close</button>
                        <button v-if="selectedUsers.length" type="submit" class="ju-modal-btn ju-modal-btn--primary">Add selected</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
    <!-- <MediaModal ref="MediaModal" @mediaInsert="handleMediaInsert" @setMedia="handleSetFeaturedImage" /> -->
</template>
<script>

import { Modal } from "bootstrap";
import juniperApi from '@/api/juniperApi'

export default {
    name: "AddExistingUserModal",
    components: {
    },
    emits: ["usersAdded"],
    data: () => ({
        modal: null,
        users: [],
        selectedUsers: [],
        searchText: '',
        inProgress: false
    }),
    mounted() {
        this.modal = new Modal(this.$refs.addExistingUserModal);

        let addExistingUserModal = document.getElementById("addExistingUserModal");

        let self = this;
        
        addExistingUserModal.addEventListener("hidden.bs.modal", function () {
            
            self.users = [];
            self.selectedUsers = [];
            self.searchText = '';
            self.inProgress = false;
        });
    },
    watch: {
        searchText () {
            this.searchUsers();
        },
    },
    methods: {
        showModal: async function (value) {
            if (value) {
                this.modal.show();
            }
        },
        async searchUsers() {
            if (this.searchText.length > 2) {
                this.inProgress = true
                let self = this
                juniperApi
				.get(`/users-search?search=${self.searchText}&per_page=5`)
				.then(({ data }) => {
					self.users = data
					self.inProgress = false
				})
				.catch(error => {
					self.inProgress = false
					console.log(error)
				})
            } else {
                this.users = [];
            }
        },
        selectUser(id) {
            if (this.selectedUsers.includes(id)) {
                this.selectedUsers = this.selectedUsers.filter(function(userId) {return userId != id});
            } else {
                this.selectedUsers.push(id);
            }
        },
        addUsersToClient() {
            juniperApi
				.post('/' + this.$route.params.id + '/users/add-to-client', {users: this.selectedUsers})
				.then(() => {
					this.$swal.fire({
						icon: 'success',
						title: 'Users added to the client successfully!',
						timer: 4000,
					})

					this.modal.hide();
                    this.$emit("usersAdded");
				})
				.catch(error => {
					let message = ''
					if (error.response.data.error) {
						for (const [key, value] of Object.entries(error.response.data.error)) {
							console.log(key)
							message += ` ${value} \n`
						}
					}
					this.$swal.fire({
						icon: 'error',
						title: message,
						timer: 6000,
					})
				})
        }
    },
    computed: {
        
    },
    props: {
        
    },
};
</script>
<style scoped>
    .modal-content {
        border: 1px solid #e6e8ec;
        border-radius: 12px;
        box-shadow: none;
    }

    .modal-header,
    .modal-footer {
        border-color: #f0f1f4;
    }

    .modal-title {
        font-size: 1rem;
        font-weight: 600;
        color: #111827;
    }

    /* Search input — settings language */
    .modal-body .form-control {
        border: 1px solid #e6e8ec;
        border-radius: 8px;
        font-size: 0.9rem;
        padding: 0.45rem 0.7rem;
        box-shadow: none;
    }

    .modal-body .form-control:focus {
        border-color: #2b6cff;
        box-shadow: 0 0 0 3px rgba(43, 108, 255, 0.15);
    }

    .juniper-pick-list {
        border: 1px solid #e6e8ec;
        border-radius: 10px;
        background: #f9fafb;
    }

    /* Compact flat table (mirrors /activities) */
    .act-table {
        width: 100%;
        border-collapse: collapse;
        font-size: 13px;
    }

    .act-table thead th {
        text-align: left;
        font-weight: 600;
        color: #6c757d;
        padding: 4px 10px 8px 0;
        border-bottom: 1px solid #dee2e6;
        white-space: nowrap;
    }

    .act-table tbody td {
        padding: 7px 10px 7px 0;
        border-bottom: 1px solid #f1f3f5;
        vertical-align: middle;
        color: #2b303b;
    }

    .act-table tbody tr:last-child td {
        border-bottom: none;
    }

    .act-row {
        cursor: pointer;
    }

    .act-row:hover td {
        background: #f3f5f9;
    }

    .act-col-id {
        width: 3.5rem;
    }

    .act-muted {
        color: #8a909c;
    }

    .act-badge {
        display: inline-block;
        padding: 1px 9px;
        font-size: 11px;
        font-weight: 700;
        border-radius: 999px;
    }

    .act-badge--active {
        background: #d1e7dd;
        color: #0f5132;
    }

    .act-badge--inactive {
        background: #f8d7da;
        color: #842029;
    }

    /* Selected pick-list row */
    tr.selected td {
        background-color: #e7f1ff !important;
    }

    tr.selected td:first-child,
    tr.selected td:nth-child(2) {
        color: #0b5ed7;
        font-weight: 600;
    }

    /* Footer buttons — flat settings buttons */
    .ju-modal-btn {
        display: inline-flex;
        align-items: center;
        gap: 0.4rem;
        padding: 0.35rem 0.85rem;
        font-size: 0.85rem;
        font-weight: 600;
        border-radius: 8px;
        border: 1px solid #e6e8ec;
        background: transparent;
        color: #111827;
        cursor: pointer;
        transition: background 0.15s ease, border-color 0.15s ease;
    }

    .ju-modal-btn:hover {
        background: #f3f5f9;
    }

    .ju-modal-btn--muted {
        color: #6b7280;
    }

    .ju-modal-btn--primary {
        border-color: #111827;
    }
</style>
